import moment from "moment";
import { useParams } from "react-router-dom";
import RateYourExperience from "./RateYourExperience/RateYourExperience";
import TicketStatusLabel from "./TicketStatusLabel";
import _ from "lodash";

function ViewTicketFull({ ticket }) {
  const { ticketId } = useParams();

  const { ticket_id, description, order_status, created_at, order_id, status } =
    {
      ticket_id: "6788b8f893cf72b4f47e6376",
      pidge_id: "jrFCK21bzBSqFBlt_fcJl",
      issue_category: "OTHERS",
      issue_subcategory: "RIDER_BEHAVIOR",
      description: "ORDER NOT YET DELIVERED",
      status: "OPEN",
      created_at: "2025-01-16T07:44:56.655Z",
      order_status: "PENDING",
      update_info: {
        callback_url: "https://play.svix.com/in/e_AIR7WIno8Vkqb0qWiwYBLheWwql/",
        callback_auth: "Bearer msdbksfsdf",
        poc_number: "999988881111",
        poc_email: "helpdesk@client.com",
      },
    };
  return (
    <>
      <div className="p-5 text-sm font-custom bg-white rounded-[20px] shadow-[0px_0px_4px_0px_rgba(166,166,166,0.25)]">
        <div className="flex justify-between items-center">
          <div className="text-stone-500 font-medium">
            Ticket ID:{" "}
            <span className="text-stone-900 font-bold">{ticket_id}</span>
          </div>
          <TicketStatusLabel status={status} size="medium" />
        </div>

        <div className="mt-5 text-sm">
          <div className="text-stone-900 font-semibold">Query:</div>
          <div className="text-stone-500 font-medium">{description}</div>
        </div>

        <div className="my-6 h-[1px] bg-neutral-200" />

        <div className="text-sm space-y-4 text-stone-500 font-medium">
          <div className="flex w-full items-center justify-between">
            <div>Ticket Raised On:</div>
            <div>{moment(created_at).format("DD/MM/YY")}</div>
          </div>
          <div className="flex w-full items-center justify-between">
            <div>Order ID:</div>
            <div>{order_id ?? "N/A"}</div>
          </div>
          <div className="flex w-full items-center justify-between">
            <div>Order Status:</div>
            <div>{_.capitalize(order_status)}</div>
          </div>
        </div>

        <button className="block mx-auto mt-10 px-7 py-2 bg-white rounded-3xl outline outline-1 outline-offset-[-1px] outline-violet-900 text-violet-900 text-sm font-bold">
          View Order
        </button>
      </div>

      <RateYourExperience />
    </>
  );
}

export default ViewTicketFull;
